import { useInfiniteQuery } from "react-query";
import { filterMarketplacePayload } from "./marketplaceProductVisibility";

const fetchProductsPage = async (apiPath, pageParam = 1) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/product/${apiPath}?page=${pageParam}`,
    { headers: { "Content-Type": "application/json" } }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }

  const data = await response.json();
  return filterMarketplacePayload(data);
};

const useInfiniteProducts = (queryKey, apiPath) =>
  useInfiniteQuery(
    queryKey,
    ({ pageParam = 1 }) => fetchProductsPage(apiPath, pageParam),
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.currentPage + 1;
        const total = lastPage.totalProducts || 0;
        return nextPage <= Math.ceil(total / 10) ? nextPage : undefined;
      },
    }
  );

export default useInfiniteProducts;
